import React from 'react';
import Checkbox from 'rsuite/Checkbox';
import CheckboxGroup from 'rsuite/CheckboxGroup';
import SelectPicker from 'rsuite/SelectPicker';
import OptionTitle from 'components/OptionElements/OptionTitle';
import OptionDescription from 'components/OptionElements/OptionDescription';
import OptionLabel from 'components/OptionElements/OptionLabel';
import OptionPrice from 'components/OptionElements/OptionPrice';
import OptionFootnote from 'components/OptionElements/OptionFootnote';
import OptionDropdown from 'components/OptionElements/OptionDropdown';
import { useCheckboxGroup } from '../hooks';
import * as Utils from 'utils';

export default function OptionTypeCheckbox(props) {
  const {options} = props;
  const [optionsIds, onChangeOptionsIds, onChangeSelectValue] = useCheckboxGroup(props);

  return (
    <CheckboxGroup
      className="app-option-list"
      value={optionsIds}
      onChange={onChangeOptionsIds}>
      {options.map((option) => {
        const {
          id,
          label = '',
          labelTooltip = '',
          title = '',
          description = '',
          footnote = '',
          dropdownTitle = '',
          dropdownContent = '',
          priceTitle = '',
          customClass = '',
          selectValue = null,
          selectValueList = null,
          isDisabled = false
        } = option;

        return (
          <div
            className={`app-option-item ${customClass} ${selectValueList && selectValueList.length > 0 ? 'is-select-list': ""}`}
            key={id}>
            <OptionTitle title={title} />
            <OptionDescription description={description} />
            <Checkbox
              className="app-option-checkbox"
              value={id}
              disabled={isDisabled}>
              <OptionLabel
                label={label}
                labelTooltip={labelTooltip}
              />
              <OptionPrice
                priceTitle={priceTitle}
                priceValueText={Utils.replacer(option, 'priceValueText')}
              />
            </Checkbox>
            {selectValueList && selectValueList.length > 0 && (
              <SelectPicker
                defaultValue={selectValue}
                data={selectValueList}
                cleanable={false}
                searchable={false}
                onChange={(value) => onChangeSelectValue(value, option)}
              />
            )}
            <OptionDropdown
              dropdownTitle={dropdownTitle}
              dropdownContent={dropdownContent}
            />
            <OptionFootnote footnote={footnote} />
          </div>
        )
      })}
    </CheckboxGroup>
  )
}
